import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { connect } from 'react-redux';
import { removeToastAndAddToastFromQueue } from 'actions/snackbar';

export const SnackbarContainer = ({ toasts, autohide, className, removeToast }) => {
  const [open, setOpen] = useState(false);
  const [currentToast, setCurrentToast] = useState(null);

  useEffect(() => {
    if (toasts && toasts.length > 0 && !currentToast) {
      setCurrentToast(toasts[0]);
      setOpen(true);
    }
  }, [toasts, currentToast]);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const handleExited = () => {
    setCurrentToast(null);
    removeToast();
  };

  // Map className to MUI Alert severity
  const getSeverity = () => {
    if (className === 'success') return 'success';
    if (className === 'error') return 'error';
    if (className === 'warning') return 'warning';
    if (className === 'info') return 'info';
    return 'info'; // default
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={autohide ? 3000 : null}
      onClose={handleClose}
      TransitionProps={{ onExited: handleExited }}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Alert 
        onClose={handleClose} 
        severity={getSeverity()} 
        variant="filled"
        sx={{ 
          minHeight: '60px',
          fontSize: '1rem',
          alignItems: 'center',
          '& .MuiAlert-action': {
            '& .MuiSvgIcon-root': {
              color: 'white'
            }
          }
        }}
      >
        {currentToast?.text || ''}
      </Alert>
    </Snackbar>
  );
};

const mapStateToProps = (state) => {
  return {
    toasts: state.snackbar.toasts,
    autohide: state.snackbar.autohide,
    className: state.snackbar.className
  };
};

const mapDispatchToProps = (dispatch) => ({
  removeToast() {
    dispatch(removeToastAndAddToastFromQueue());
  }
});

SnackbarContainer.propTypes = {
  toasts: PropTypes.array.isRequired,
  autohide: PropTypes.bool.isRequired,
  className: PropTypes.string.isRequired,
  removeToast: PropTypes.func.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(SnackbarContainer);
